import axios from '@axios'

const PREFIX = '/monitoramento-360'

export default {
  getPaginado(page, pageSize, filtros, filtroString) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}&multiFiltro=${filtroString}`, filtros)
  },

  baixarEmExcel(tipo, filtros) {
    return axios.post(`${PREFIX}/baixa-excel`, filtros)
  },

  deletarExcel(url, nomeArquivo) {
    axios.post(`${PREFIX}/deletar-excel?url=${url}&nomeArquivo=${nomeArquivo}`)
  },
  getPendencias(id) {
    return axios.get(`${PREFIX}/${id}/pendencias`)
  },

  baixarDocumentos(id, docs = null) {
    const query = docs && docs.length > 0 ? `?docs=${docs.join(',')}` : ''
    return axios.post(`${PREFIX}/${id}/baixar${query}`)
  },

  visualizarDocumentos(id, docs = null) {
    const query = docs && docs.length > 0 ? `?docs=${docs.join(',')}` : ''
    return axios.post(`${PREFIX}/${id}/visualizar${query}`)
  },

  getObservacoes(id) {
    return axios.get(`${PREFIX}/${id}/observacao`)
  },

  salvarObservacao(dto) {
    return axios.post(`${PREFIX}/observacao/salvar`, dto)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },
}
